import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

function usePointCards() {
  const { data, status } = useQuery(queries.point.cardList({ page: 0, size: 512 }));
  const { pop } = useFlow();
  const toast = useToast();
  useEffect(() => {
    if (status === 'error') {
      toast.error('포인트 카드 목록을 가져오는 데 실패했습니다.');
      pop();
    }
  }, [toast, pop, status]);
  return data?.content;
}

export default usePointCards;
